import angular from 'angular';

angular.module('cloudX').factory('dialogsSvc', ['$q', 'ModalService', '$timeout', dialogsSvc]);

function dialogsSvc($q, ModalService, $timeout) {
  function showModal(modalOptions) {
    var deferred = $q.defer();
    ModalService.showModal(modalOptions).then(function(modal) {
      modal.element.modal();
      modal.close.then(function(result) {
        if (result) deferred.resolve(result);
        else deferred.reject(null);
      }, deferred.reject);
    });
    return deferred.promise;
  }

  return {
    //Returns promise,
    showYesNo: function(title, message, params) {
      return showModal({
        template: require('./yesNoDialog.html'),
        controller: 'YesNoDialogCtrl',
        locationChangeSuccess: false,
        inputs: {
          title: title,
          message: message,
          params: params,
        },
      });
    },
    showYesNoList: function(title, message, items) {
      return showModal({
        template: require('./yesNoListDialog.html'),
        controller: 'YesNoListDialogCtrl',
        locationChangeSuccess: false,
        inputs: {
          title: title,
          message: message,
          items: items,
        },
      });
    },
    showOkCancel: function(title, message) {
      return showModal({
        template: require('./okCancelDialog.html'),
        controller: 'OkCancelDialogCtrl',
        locationChangeSuccess: false,
        inputs: {
          title: title,
          message: message,
        },
      });
    },
    showYesNoCancelList: function(title, message, items) {
      var deferred = $q.defer();
      ModalService.showModal({
        template: require('./yesNoCancelListDialog.html'),
        controller: 'YesNoCancelListDialogCtrl',
        locationChangeSuccess: false,
        inputs: {
          title: title,
          message: message,
          items: items,
        },
      }).then(function(modal) {
        modal.element.modal();
        modal.close.then(deferred.resolve, deferred.reject);
        modal.element.on('hidden.bs.modal', function(e) {
          modal.element.off(e);
          modal.element.remove();
          $timeout(() => {
            deferred.resolve(null);
          }, 1000);
        });
      });
      return deferred.promise;
    },
    showYesNoCancel: function(title, message) {
      var deferred = $q.defer();
      ModalService.showModal({
        template: require('./yesNoCancelDialog.html'),
        controller: 'YesNoCancelDialogCtrl',
        locationChangeSuccess: false,
        inputs: {
          title: title,
          message: message,
        },
      }).then(function(modal) {
        modal.element.modal();
        modal.close.then(deferred.resolve, deferred.reject);
        modal.element.on('hidden.bs.modal', function(e) {
          modal.element.off(e); //Remove event
          modal.element.remove(); //Remove element
          $timeout(() => {
            deferred.resolve(null);
          }, 1000);
        });
      });
      /* Returns promise with these values:
       * null: cancel
       * true: yes
       * false: no
       */
      return deferred.promise;
    },
    confirmTemplateChanges: function(title, message, showResetDeviations) {
      var deferred = $q.defer();
      ModalService.showModal({
        template: require('./confirmTemplateChangesDialog.html'),
        controller: 'ConfirmTemplateChangesDialogCtrl',
        locationChangeSuccess: false,
        inputs: {
          title: title,
          message: message,
          showResetDeviations: showResetDeviations,
        },
      }).then(function(modal) {
        modal.element.modal();
        modal.close.then(deferred.resolve, deferred.reject);
        modal.element.on('hidden.bs.modal', function(e) {
          modal.element.off(e); //Remove event
          modal.element.remove(); //Remove element
          $timeout(() => {
            deferred.resolve({ result: null, resetDeviations: false });
          }, 1000);
        });
      });
      /* Returns promise resolving to an object { result, resetDeviations }
       * result null: cancel
       * result true: yes
       * result false: no
       */
      return deferred.promise;
    },
    showAvailableRelationTags: function() {
      var deferred = $q.defer();
      ModalService.showModal({
        template: require('./availableRelationTagsDialog.html'),
        controller: 'AvailableRelationTagsDialogCtrl',
        locationChangeSuccess: false,
      }).then(function(modal) {
        modal.element.modal();
        modal.close.then(deferred.resolve, deferred.reject);
      });
      return deferred.promise;
    },
    showSimilarRelations: function(similarRelations) {
      var deferred = $q.defer();
      ModalService.showModal({
        template: require('./similarRelationDialog.html'),
        controller: 'SimilarRelationDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          similarRelations: similarRelations,
        },
      }).then(function(modal) {
        modal.element.modal();
        modal.close.then(deferred.resolve, deferred.reject);
      });
      return deferred.promise;
    },
    showExternalRelationSearchDialog: function(searchTerm, searchProvider) {
      var deferred = $q.defer();
      ModalService.showModal({
        template: require('./externalRelationSearchDialog.html'),
        controller: 'ExternalRelationSearchDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          searchTerm: searchTerm,
          searchProvider: searchProvider,
        },
      }).then(function(modal) {
        modal.element.modal();
        modal.close.then(deferred.resolve, deferred.reject);
      });
      return deferred.promise;
    },
    showRelationWizard: function(title, wizardOptions) {
      return showModal({
        template: require('./relationWizardDialog.html'),
        controller: 'RelationWizardDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          title: title,
          wizardOptions: wizardOptions,
        },
      });
    },
    showDistanceDialog: function(relationId, companyId) {
      return showModal({
        template: require('./calcDistanceDialog.html'),
        controller: 'CalcDistanceDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          relationId,
          companyId,
        },
      });
    },
    //Translations
    translateListItem: function(list, listid, fallback, options = {}) {
      return showModal({
        template: require('./translateListItemDialog.html'),
        controller: 'TranslateListItemDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          list,
          listid,
          fallback,
          options,
        },
      });
    },

    updateInternalPrice: function(internalPrice) {
      return showModal({
        template: require('./updateRegistrationsInternalPriceDialog.html'),
        controller: 'UpdateRegistrationsInternalPriceDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          internalPrice: internalPrice,
        },
      });
    },

    shareItem: function(type, id, itemName, relationName) {
      return showModal({
        template: require('./shareItemDialog.html'),
        controller: 'ShareItemDialogCtrl',
        controllerAs: 'vm',
        locationChangeSuccess: false,
        inputs: {
          type: type,
          id: id,
          itemName: itemName,
          relationName: relationName,
        },
      });
    },

    showCheckboxList: function(title, items) {
      return showModal({
        template: require('./checkboxListDialog.html'),
        controller: 'CheckboxListDialogCtrl',
        locationChangeSuccess: false,
        inputs: {
          title: title,
          items: items,
        },
      });
    },
    confirmChanges: function(title, message, showSaveButton = false) {
      var deferred = $q.defer();
      ModalService.showModal({
        template: require('./confirmChangesDialog.html'),
        controller: 'ConfirmChangesDialogCtrl',
        locationChangeSuccess: false,
        inputs: {
          title: title,
          message: message,
          showSaveButton: showSaveButton,
        },
      }).then(function(modal) {
        modal.element.modal();
        modal.close.then(deferred.resolve, deferred.reject);
        modal.element.on('hidden.bs.modal', function(e) {
          modal.element.off(e); //Remove event
          modal.element.remove(); //Remove element
        });
      });
      /* Returns promise with these values:
       * null || 0: cancel
       * 1: Discard changes
       * 2: Save changes
       */
      return deferred.promise;
    },
    showStringInput: function(title, message, placeholder = '', value = '') {
      return showModal({
        template: require('./stringInputDialog.html'),
        controller: 'StringInputDialogCtrl',
        locationChangeSuccess: false,
        inputs: {
          title: title,
          message: message,
          placeholder,
          value,
        },
      });
    },
  };
}
